export const ASC = 'ASC';
export const DESC = 'DESC';

export const SMALL = 'small';
export const LARGE = 'large';

export const LOADING_CONTENTS_OPACITY = 0.22;
